import NumericFormat from "react-number-format";
import RequestConfig from "../mini_components/RequestConfig";
import { convertToJalali } from "../mini_components/ConvertToJalali";
import { Link } from "react-router-dom";

const IncomeCard = ({ item }) => {
  const amountIsNegetive = item.amount < 0;
  const handleRecive = async (id) => {
    try {
      const response = await await RequestConfig.get(
        `incomes/recipe/url/${id}/`
      );
      if (response.status === 200 || response.status === 201) {
        window.open(response.data.file_url, "_blank");
      }
    } catch (error) {
      console.error("Error processing form:", error);
    }
  };

  return (
    <Link className="card-box-wrapper " title="جزئیات" to={`#`}>
      <div className="flex justify-between items-center w-full ">
        <h2 className="max-w-[200px] truncate text-[16px]  font-semibold">
          سامانه {item.application}
        </h2>
        <div className=" flex items-center font-bold text-[16px] gap-2">
          <div>
            <NumericFormat
              value={Math.abs(item.amount)}
              displayType={"text"}
              thousandSeparator={true}
            />
            {amountIsNegetive && <span className="">-</span>}
          </div>
          <span className="card-box-wrapper-date-text">ریال</span>
        </div>
      </div>

      <div className="flex justify-between items-center">
        <p className="card-box-wrapper-date-text " dir="ltr">
          {" "}
          {convertToJalali(item.created_at)}
        </p>
        <button
          onClick={() => handleRecive(item.id)}
          className=" flex gap-2 items-center    pr-2  w-fit mr-auto  "
        >
          <FormStateCard revert={item.revert} />
          <img src="/icons/download-square.svg" alt="" width={34} height={34} />
        </button>
      </div>
    </Link>
  );
};
export default IncomeCard;

const FormStateCard = ({ revert }) => {
  const statesArray = [
    {
      state: false,
      text: "تایید ونداولت",
      className:
        " px-[6px] py-1 rounded-md text-success-90 bg-[#DCFCE7] text-title-sm-regular flex gap-2",
    },
    {
      state: true,
      text: "برگشت داده شده",
      className:
        "text-error-90 bg-error-20 px-[4px] py-1 rounded-md  text-title-sm-regular flex gap-2",
    },
  ];

  const activeItem = statesArray.find((item) => item.state === revert);

  return (
    <div className={activeItem?.className}>
      {/* <img src="/icons/supporterIcon.svg" alt="" width={16} height={16} /> */}
      {activeItem?.text}
    </div>
  );
};

